import { gql } from '@apollo/client'
import { POINT_OF_INTEREST_FRAGMENT } from '../fragments'

export const UPDATE_PICOS_POI = gql`
  mutation UpdatePicOSPOI($input: UpdatePicOSPOIInput!) {
    updatePicosPoi(input: $input) {
      picosPoi {
        ...PointOfInterest
      }
    }
  }
  ${POINT_OF_INTEREST_FRAGMENT}
`
